import { ConfigProvider,   theme as antdTheme } from "antd";
import { AdminComponent } from "../components/adminComponent";
import { useCallback,  useState } from "react";




export const AdminPage = ({handleLogout}) => {
    const [isDarkMode, setIsDarkMode] = useState(true);

    const toggleTheme = useCallback(() => {        
        setIsDarkMode(prevState => !prevState);
    }, []);     
      


  return (
    <ConfigProvider
          theme={{
            algorithm: isDarkMode
              ? antdTheme.darkAlgorithm
              : antdTheme.defaultAlgorithm,
          }}
        >
            <div
        style={{
          minHeight: '100vh',
          padding: 24,
          background: isDarkMode ? '#141414' : '#f0f2f5',
          transition: 'all 0.3s ease',
        }}
      >
      <AdminComponent isDarkMode={isDarkMode} changeTheme={toggleTheme} handleLogout={handleLogout}/>

      </div>
            
    </ConfigProvider>
  );
}
